import { ReactNode, useMemo, useState } from 'react';
import { useSuppressedFilter } from '../../state/FilterContext';
import { services } from '../../globals';
import { useSiteContext } from '../../state/SiteContext';
import { TextExtractor, findFirstComponentOfType } from '../internal/TextExtractor';

interface DirectLinkProps {
  children: ReactNode[],
  suppress?: string,
  target?: string,
}

/***
 * A component that renders a link to the file on the server.
 */
export function DirectLink({ children, suppress, target }: DirectLinkProps): React.ReactElement {
  const linkedState = useSuppressedFilter(suppress || "");
  const { siteState } = useSiteContext();

  // Get to value from the to child
  const [toValue, setToValue] = useState("");
  const toChild = useMemo(() => findFirstComponentOfType(children, "arg-to"), [children]);

  // Get the content to render in the link
  const linkDisplay = useMemo(() => findFirstComponentOfType(children, "arg-display"), [children]);

  const link = services.file.getDirectLink(
    siteState.site?.name || "",
    toValue,
    linkedState.validity || "",
    linkedState.systemProperties || {},
    linkedState.lang || "",
  ) || "";
  return <>
    {toChild && (
      <TextExtractor onExtractedText={setToValue}>
        {toChild?.props.children}
      </TextExtractor>
    )}
    <a href={link} target={target}>{linkDisplay?.props.children || children}</a>
  </>;
}